var map = {
	"./DJI_0335.jpg": 6454,
	"./IMG_3949.JPEG": 3676,
	"./IMG_3959.JPEG": 7113,
	"./IMG_3977.JPEG": 9241,
	"./IMG_5054.JPEG": 7707,
	"./basile1.jpg": 3008,
	"./starfish1.jpg": 8996,
	"./swim1.jpg": 698,
	"./tom_tess_dinghy.jpg": 5489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2261;